import TSAbstractEntity from './TSAbstractEntity';
import {TSSerializable} from './TSSerializable';
import {TSAnrede} from './enums/TSAnrede';
import {TSSprache} from './enums/TSSprache';

export default class TSAbstractPersonEntity extends TSAbstractEntity implements TSSerializable<TSAbstractPersonEntity> {

    private _anrede: TSAnrede;

    private _korrespondenzsprache: TSSprache;

    private _vorname: string;

    private _nachname: string;

    public get anrede(): TSAnrede {
        return this._anrede;
    }

    public set anrede(value: TSAnrede) {
        this._anrede = value;
    }

    public get korrespondenzsprache(): TSSprache {
        return this._korrespondenzsprache;
    }

    public set korrespondenzsprache(value: TSSprache) {
        this._korrespondenzsprache = value;
    }

    public get vorname(): string {
        return this._vorname;
    }

    public set vorname(value: string) {
        this._vorname = value;
    }

    public get nachname(): string {
        return this._nachname;
    }

    public set nachname(value: string) {
        this._nachname = value;
    }

    deserialize(restObject: any): TSAbstractPersonEntity {
        super.deserialize(restObject);
        this.nachname = restObject.nachname;
        this.vorname = restObject.vorname;
        this.korrespondenzsprache = restObject.korrespondenzsprache;
        this.anrede = restObject.anrede;

        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);
        restObject.nachname = this.nachname;
        restObject.vorname = this.vorname;
        restObject.korrespondenzsprache = this.korrespondenzsprache;
        restObject.anrede = this.anrede;
        return restObject;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSAbstractPersonEntity.ts